import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vShow as _vShow, vModelCheckbox as _vModelCheckbox, toDisplayString as _toDisplayString, withCtx as _withCtx, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "card mb-4 mb-md-0" }
const _hoisted_2 = { class: "card-header border-0 pt-6" }
const _hoisted_3 = { class: "card-title" }
const _hoisted_4 = { class: "svg-icon svg-icon-1 me-2" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Search Panel ")
const _hoisted_6 = { class: "card-toolbar" }
const _hoisted_7 = {
  key: 0,
  class: "d-flex justify-content-end",
  "data-kt-site-table-toolbar": "base"
}
const _hoisted_8 = { class: "svg-icon svg-icon-2" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" Add Production ")
const _hoisted_10 = { class: "card-header border-0 pt-6" }
const _hoisted_11 = { class: "card-title w-100" }
const _hoisted_12 = { class: "row w-100" }
const _hoisted_13 = { class: "col-md-6 d-flex align-items-center position-relative my-1" }
const _hoisted_14 = { class: "col-md-6 d-flex align-items-center position-relative my-1" }
const _hoisted_15 = { class: "col-md-6 d-flex align-items-center position-relative my-1" }
const _hoisted_16 = { class: "col-md-6 d-flex align-items-center position-relative my-1" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold mb-2 mx-2 px-2" }, "Status", -1)
const _hoisted_18 = /*#__PURE__*/_createStaticVNode("<option value=\"\">All</option><option value=\"Not Started\">NOT STARTED</option><option value=\"In Progress\">IN PROGRESS</option><option value=\"Completed\">COMPLETED</option><option value=\"Dispatched\">DISPATCHED</option>", 5)
const _hoisted_23 = [
  _hoisted_18
]
const _hoisted_24 = { class: "card-toolbar" }
const _hoisted_25 = {
  class: "d-flex justify-content-end align-items-center",
  "data-kt-site-table-toolbar": "selected"
}
const _hoisted_26 = {
  key: 0,
  class: "card-body pt-0"
}
const _hoisted_27 = { class: "form-check form-check-sm form-check-custom form-check-solid" }
const _hoisted_28 = ["value"]
const _hoisted_29 = ["value"]
const _hoisted_30 = ["href"]
const _hoisted_31 = ["src"]
const _hoisted_32 = { class: "d-flex pt-1 justify-content-end" }
const _hoisted_33 = ["onClick"]
const _hoisted_34 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-pencil p-0" }, null, -1)
const _hoisted_35 = [
  _hoisted_34
]
const _hoisted_36 = ["onClick"]
const _hoisted_37 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-trash p-0" }, null, -1)
const _hoisted_38 = [
  _hoisted_37
]
const _hoisted_39 = ["onClick"]
const _hoisted_40 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-plus-slash-minus p-0" }, null, -1)
const _hoisted_41 = [
  _hoisted_40
]
const _hoisted_42 = { class: "d-flex pt-1 justify-content-end" }
const _hoisted_43 = ["onClick"]
const _hoisted_44 = ["onClick"]
const _hoisted_45 = { class: "d-none" }
const _hoisted_46 = {
  key: 0,
  class: "card"
}
const _hoisted_47 = { class: "card-body" }
const _hoisted_48 = /*#__PURE__*/_createElementVNode("h4", null, "No Data Found", -1)
const _hoisted_49 = /*#__PURE__*/_createTextVNode(" to add new production ")
const _hoisted_50 = { class: "card-header ribbon" }
const _hoisted_51 = { class: "card-title" }
const _hoisted_52 = { class: "ribbon-label bg-info" }
const _hoisted_53 = { class: "card-body px-0 pb-0 d-flex align-items-center mb-2" }
const _hoisted_54 = /*#__PURE__*/_createElementVNode("span", { class: "bullet bullet-vertical h-40px me-3" }, null, -1)
const _hoisted_55 = { class: "flex-grow-1" }
const _hoisted_56 = { class: "d-flex" }
const _hoisted_57 = { class: "ms-4" }
const _hoisted_58 = { class: "text-muted fw-bold d-block" }
const _hoisted_59 = { class: "text-muted fw-bold d-block" }
const _hoisted_60 = { class: "text-muted fw-bold d-block" }
const _hoisted_61 = { class: "card-footer d-flex pt-1" }
const _hoisted_62 = ["onClick"]
const _hoisted_63 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-pencil" }, null, -1)
const _hoisted_64 = [
  _hoisted_63
]
const _hoisted_65 = ["onClick"]
const _hoisted_66 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-trash" }, null, -1)
const _hoisted_67 = [
  _hoisted_66
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_PartyMultiselect = _resolveComponent("PartyMultiselect")!
  const _component_DesignMultiselect = _resolveComponent("DesignMultiselect")!
  const _component_SeasonMultiselect = _resolveComponent("SeasonMultiselect")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Datatable = _resolveComponent("Datatable")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", {
            class: "d-flex align-items-center position-relative my-1 cursor-pointer",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showSearchPanel = !_ctx.showSearchPanel))
          }, [
            _createElementVNode("span", _hoisted_4, [
              _createVNode(_component_inline_svg, { src: "media/icons/duotune/abstract/abs027.svg" })
            ]),
            _hoisted_5
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          (_ctx.hasCreate)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-primary",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.addProduction()))
                }, [
                  _createElementVNode("span", _hoisted_8, [
                    _createVNode(_component_inline_svg, { src: "media/icons/duotone/navigation/Plus.svg" })
                  ]),
                  _hoisted_9
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _createVNode(_component_PartyMultiselect, {
                isEdit: true,
                modelValue: _ctx.searchData.party_id,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.searchData.party_id) = $event)),
                class: "form-control"
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_14, [
              _createVNode(_component_DesignMultiselect, {
                isEdit: true,
                modelValue: _ctx.searchData.design_id,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.searchData.design_id) = $event)),
                class: "form-control",
                party: _ctx.searchData.party_id
              }, null, 8, ["modelValue", "party"])
            ]),
            _createElementVNode("div", _hoisted_15, [
              _createVNode(_component_SeasonMultiselect, {
                isEdit: true,
                modelValue: _ctx.searchData.season_id,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.searchData.season_id) = $event)),
                class: "form-control"
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_16, [
              _hoisted_17,
              _withDirectives(_createElementVNode("select", {
                class: "form-select rounded-3",
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.searchData.status) = $event))
              }, _hoisted_23, 512), [
                [_vModelSelect, _ctx.searchData.status]
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_24, [
          _createElementVNode("div", _hoisted_25, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-info me-2",
              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.searchItems()))
            }, " Search "),
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-danger",
              onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.clearFilter()))
            }, " Clear "),
            (_ctx.hasCost)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  type: "button",
                  class: "btn btn-info mx-2",
                  onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.exportFewSites()))
                }, " Export CSV Selected "))
              : _createCommentVNode("", true)
          ])
        ])
      ], 512), [
        [_vShow, _ctx.showSearchPanel]
      ]),
      (!_ctx.isLoading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
            _createVNode(_component_Datatable, {
              "table-data": _ctx.tableData,
              "table-header": _ctx.tableHeader,
              "enable-items-per-page-dropdown": false,
              total: _ctx.total,
              rowsPerPage: 10,
              onPageChange: _ctx.onPageChange,
              currentPage: _ctx.currentPage
            }, {
              "cell-checkbox": _withCtx(({ row: site }) => [
                _createElementVNode("div", _hoisted_27, [
                  (_ctx.selectAllProduction)
                    ? (_openBlock(), _createElementBlock("input", {
                        key: 0,
                        class: "form-check-input",
                        type: "checkbox",
                        value: site.id,
                        checked: "",
                        disabled: ""
                      }, null, 8, _hoisted_28))
                    : _withDirectives((_openBlock(), _createElementBlock("input", {
                        key: 1,
                        class: "form-check-input",
                        type: "checkbox",
                        value: site.id,
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.checkedProduction) = $event))
                      }, null, 8, _hoisted_29)), [
                        [_vModelCheckbox, _ctx.checkedProduction]
                      ])
                ])
              ]),
              "cell-qty": _withCtx(({ row: site }) => [
                _createTextVNode(_toDisplayString(site.qty), 1)
              ]),
              "cell-design_data": _withCtx(({ row: site }) => [
                _createVNode(_component_router_link, {
                  to: {
                name: 'apps-edit-design',
                params: { id: site.design_data.id },
              }
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(site.design_data.code), 1)
                  ]),
                  _: 2
                }, 1032, ["to"])
              ]),
              "cell-season_data": _withCtx(({ row: site }) => [
                _createTextVNode(_toDisplayString(site.season_data.name), 1)
              ]),
              "cell-dueDate": _withCtx(({ row: site }) => [
                _createTextVNode(_toDisplayString(_ctx.moment(site.dueDate).format("YYYY-MM-DD")), 1)
              ]),
              "cell-dateIn": _withCtx(({ row: site }) => [
                _createTextVNode(_toDisplayString(_ctx.moment(site.dateIn).format("YYYY-MM-DD")), 1)
              ]),
              "cell-dateOut": _withCtx(({ row: site }) => [
                _createTextVNode(_toDisplayString(_ctx.moment(site.dateOut).format("YYYY-MM-DD")), 1)
              ]),
              "cell-color": _withCtx(({ row: site }) => [
                _createElementVNode("div", {
                  style: _normalizeStyle({
                backgroundColor: site.color,
                width: '100px',
                height: '100px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              })
                }, _toDisplayString(site.color), 5)
              ]),
              "cell-created_by": _withCtx(({ row: site }) => [
                _createElementVNode("span", null, _toDisplayString(_ctx.userList[site.created_by]?.name), 1)
              ]),
              "cell-image": _withCtx(({ row: site }) => [
                _createElementVNode("span", null, [
                  _createElementVNode("a", {
                    href: site.design_data.image,
                    target: "_blank"
                  }, [
                    _createElementVNode("img", {
                      class: "img-thumbnail",
                      src: site.design_data.image,
                      style: {"max-height":"150px"}
                    }, null, 8, _hoisted_31)
                  ], 8, _hoisted_30)
                ])
              ]),
              "cell-actions": _withCtx(({ row: site }) => [
                _createElementVNode("div", _hoisted_32, [
                  (_ctx.hasEdit)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        type: "button",
                        class: "btn btn-primary btn-sm mx-2",
                        onClick: ($event: any) => (_ctx.addProduction(site.id))
                      }, _hoisted_35, 8, _hoisted_33))
                    : _createCommentVNode("", true),
                  (_ctx.hasDelete)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 1,
                        type: "button",
                        class: "btn btn-danger btn-sm mx-2",
                        onClick: ($event: any) => (_ctx.deleteProductionItem(site))
                      }, _hoisted_38, 8, _hoisted_36))
                    : _createCommentVNode("", true),
                  (_ctx.hasStock)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 2,
                        type: "button",
                        class: "btn btn-info btn-sm mx-2",
                        onClick: ($event: any) => (_ctx.stockProductionItem(site.id))
                      }, _hoisted_41, 8, _hoisted_39))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_42, [
                  (_ctx.hasPeelingAndCutting)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        type: "button",
                        class: "btn btn-info btn-sm mx-2",
                        onClick: ($event: any) => (
                  _ctx.designMaterialProductionLanding(site.id, site.design_id)
                )
                      }, " Cutting/Peeling ", 8, _hoisted_43))
                    : _createCommentVNode("", true),
                  (_ctx.hasFusing)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 1,
                        type: "button",
                        class: "btn btn-info btn-sm mx-2",
                        onClick: ($event: any) => (_ctx.fusingProductionLanding(site.id, site.design_id))
                      }, " Fusing ", 8, _hoisted_44))
                    : _createCommentVNode("", true)
                ])
              ]),
              _: 1
            }, 8, ["table-data", "table-header", "total", "onPageChange", "currentPage"])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_45, [
      _createElementVNode("div", null, [
        (_ctx.tableData.length == 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
              _createElementVNode("div", _hoisted_47, [
                _hoisted_48,
                _createElementVNode("p", null, [
                  _createElementVNode("span", {
                    onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.addProduction({}))),
                    class: "cursor-pointer text-primary"
                  }, "Click here"),
                  _hoisted_49
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableData, (item) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "card card-flush mb-4 shadow",
            key: item.id
          }, [
            _createElementVNode("div", _hoisted_50, [
              _createElementVNode("h3", _hoisted_51, _toDisplayString(item.code), 1),
              _createElementVNode("div", _hoisted_52, _toDisplayString(_ctx.userList[item.created_by]?.username), 1)
            ]),
            _createElementVNode("div", _hoisted_53, [
              _hoisted_54,
              _createElementVNode("div", _hoisted_55, [
                _createElementVNode("div", _hoisted_56, [
                  _createElementVNode("div", {
                    style: _normalizeStyle({
                    backgroundColor: item.color,
                    width: '100px',
                    height: '100px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                  })
                  }, _toDisplayString(item.color), 5),
                  _createElementVNode("div", _hoisted_57, [
                    _createElementVNode("div", _hoisted_58, " Unit: " + _toDisplayString(item.unit), 1),
                    _createElementVNode("div", _hoisted_59, " Rate : ₹ " + _toDisplayString(item.rate), 1),
                    _createElementVNode("div", _hoisted_60, " Purchase Cost: ₹ " + _toDisplayString(item.purchaseCost), 1)
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_61, [
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-primary mx-2 w-100",
                onClick: ($event: any) => (_ctx.addProduction(item.id))
              }, _hoisted_64, 8, _hoisted_62),
              false
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    type: "button",
                    class: "btn btn-danger mx-2 w-100",
                    onClick: ($event: any) => (_ctx.deleteProductionItem(item))
                  }, _hoisted_67, 8, _hoisted_65))
                : _createCommentVNode("", true)
            ])
          ]))
        }), 128))
      ])
    ])
  ]))
}